import { useGuideContext } from "@/components/providers/GuideProvider";
export function useGuide() {
  return useGuideContext();
}